import { GET_ALL_LANGUAGES, GET_SINGLE_LANGUAGE_DATA } from "./actionTypes";

import Axios from "axios";
import {
  GET_ALL_LANGUAGES_URL,
  GET_SINGLE_LANGUAGE_DATA_URL,
} from "../../configs";

export const getAllLanguages = () => (dispatch) => {
  return Axios.post(GET_ALL_LANGUAGES_URL)
    .then((response) => {
      const languages = response.data;
      return dispatch({ type: GET_ALL_LANGUAGES, payload: languages });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const getSingleLanguageData = (id) => (dispatch) => {
  // console.log('🌐 Calling getSingleLanguageData with ID:', id);
  return Axios.post(GET_SINGLE_LANGUAGE_DATA_URL, {
    id: id,
  })
    .then((response) => {
      // console.log('🌐 Raw API response:', response);
      // console.log('🌐 Response data:', response.data);
      // console.log('🌐 Response data type:', typeof response.data);
      // console.log('🌐 Is response.data an array?', Array.isArray(response.data));
      
      const language = response.data;

      // Store language data in localStorage
      if (Array.isArray(language) && language.length > 0) {
        // console.log('🌐 Processing language array with', language.length, 'items');
        language.forEach((item, index) => {
          // console.log(`🌐 Item ${index}:`, item);
          if (item.key && item.value !== null && item.value !== undefined) {
            localStorage.setItem(item.key, item.value);
            // console.log(`✅ Stored: ${item.key} = ${item.value}`);
          } else {
            // console.log(`❌ Skipped item ${index}:`, item);
          }
        });
        // console.log('✅ Language data stored in localStorage:', language.length, 'items');
      } else if (language && typeof language === 'object' && !Array.isArray(language)) {
        // Handle case where response is an object instead of array
        // console.log('🌐 Processing language object:', language);
        Object.keys(language).forEach(key => {
          if (language[key] !== null && language[key] !== undefined) {
            localStorage.setItem(key, language[key]);
            // console.log(`✅ Stored: ${key} = ${language[key]}`);
          }
        });
        // console.log('✅ Language object data stored in localStorage');
      } else {
        // console.log('❌ Unexpected language data format:', language);
      }

      return dispatch({ type: GET_SINGLE_LANGUAGE_DATA, payload: language });
    })
    .catch(function(error) {
      // console.log('❌ Error loading language data:', error);
    });
};
